import React from 'react';
import Pages from './Pages';
import Pusher from 'pusher-js';
import Echo from 'laravel-echo';
import ErrorSplash from './views/ErrorSplash';
import { BrowserRouter as Router } from 'react-router-dom';
import { fas as FontAwesomeSolid } from '@fortawesome/free-solid-svg-icons';
import { fab as FontAwesomeBrands } from '@fortawesome/free-brands-svg-icons';
import { far as FontAwesomeRegular } from '@fortawesome/free-regular-svg-icons';
import { library as FontAwesomeLibrary } from '@fortawesome/fontawesome-svg-core';
import '../css/App.css';

window.Pusher = Pusher;

window.Echo = new Echo({
  broadcaster: 'reverb',
  enabledTransports: ['ws', 'wss'],
  key: process.env.REACT_APP_REVERB_KEY,
  wsHost: process.env.REACT_APP_REVERB_HOST,
  wsPort: process.env.REACT_APP_REVERB_PORT ?? 80,
  wssPort: process.env.REACT_APP_REVERB_PORT ?? 443,
  forceTLS: (process.env.REACT_APP_REVERB_SCHEME ?? 'https') === 'https',
});

require('popper.js');
require('bootstrap');

FontAwesomeLibrary.add(FontAwesomeSolid);
FontAwesomeLibrary.add(FontAwesomeRegular);
FontAwesomeLibrary.add(FontAwesomeBrands);

window.toastr = require('toastr');
window.toastr.options.timeOut = 3000;
window.toastr.options.escapeHtml = true;
window.toastr.options.positionClass = 'toast-bottom-right';

window.Enums = {
  CARD_SORT_ORDER_TYPE: {
    CHRONOLOGICAL: 'Chronological',
    MOST_VOTES: 'Most Votes',
  },
};

export default () => (
  <ErrorSplash>
    <Router>
      <Pages />
    </Router>
  </ErrorSplash>
);
